import { Pipe, PipeTransform } from "@angular/core";
import { MemberConstants } from "@app/common/constant/member.constant";
import { AuthUtil } from "@app/common/util/auth.util";

@Pipe({ name: "cusprice" })

export class CustomerPrice implements PipeTransform {

  transform(
    customerPrice?: String | Number | string | number | undefined,
    memberPrice?: String | Number | string | number | undefined,
    agentPrice?: String | Number | string | number | undefined,
    distributorPrice?: String | Number | string | number | undefined
  ): String {

    const member = AuthUtil.getLoginedInfo();

    if (member) {
      const rankCd = member?.rankCd ? String(member.rankCd) : '';
      const numRank = rankCd.length >= 4 ? Number(rankCd.substring(2, 4)) : 0;
      const dcYn = member?.dcYn ? String(member.dcYn) : 'N';
      if(AuthUtil.checkPermissionView()) {
        return String(memberPrice ?? '');
      } else {
        if (numRank === MemberConstants.PERMISSION_MEMBERS 
          || (numRank === MemberConstants.PERMISSION_MASTER_AGENT && dcYn == 'N')
          || (numRank >= MemberConstants.PERMISSION_DISTRIBUTOR && dcYn == 'N')) {
          return String(memberPrice ?? '');
        } else if (numRank === MemberConstants.PERMISSION_MASTER_AGENT && dcYn == 'Y') {
          return String(agentPrice ?? '');
        } else if (numRank >= MemberConstants.PERMISSION_DISTRIBUTOR && dcYn == 'Y') {
          return String(distributorPrice ?? '');
        }
      }
    }

    return String(customerPrice ?? '');
  }
}